import React,{useEffect,useRef} from 'react';
import { Select } from 'antd';
import 'antd/dist/antd.css';
import {getCategoryMarketData} from '../services/chartdata'
import {fillSeries, percentOption} from '../utils/chartOptionConfig'

//按需加载
import echarts from 'echarts/lib/echarts'
//必需基础组件
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/markPoint'
//导入矩形图
import 'echarts/lib/chart/bar'　
import 'echarts/lib/chart/line'　





export default function CategoryMakret(props) {
	const { Option } = Select;

	function handleChange(value) {
		console.log(`selected ${value}`);		
		renderMyChart(value-1);
	}

	const chartRef=useRef();
	// const chartRef_2=useRef();

	const refObj={};
	refObj['轿车']=useRef();
	refObj['SUV']=useRef();
	refObj['MPV']=useRef();
	refObj['占比']=useRef();

	const categories=['SUV','MPV','轿车','占比'];
	// for(let a of categories){
	// 	refObj[str]=useRef();
	// }

	// ['轿车','SUV','MPV'].map((str)=>{
	// 	refObj[str]=useRef();
	// })



	let myChart=null;
	let myChart_2=null;
	let jsonData=null;
	let option = {		
		color: ['#264D73', '#84B5D5', '#19B3E8'],
		legend: {},
		tooltip:{
			show:true
		},
		title: {
			text: '广义乘用车'
		},
		grid: {
			show:false,
			left: '3%',
			right: '5%',
			width:'auto',			
		},
		xAxis: {
            type: 'category',
            axisTick:{                
                interval:0,
                inside:false,                
            },
            axisLabel:{
                interval:0
            }
		},
		yAxis: [{
				type: 'value',
				splitLine:{
					show:false
				},
				name: '单位： 万辆',
				axisLabel: {
					formatter: '{value}'
				}
			},
			{
				type: 'value',
				splitLine:{
					show:false
				},
				name: '',
				axisLabel: {
					formatter: '{value} %'
				}
			}
		],
		series: [{
				type: 'bar',
				barGap: 0,
				label: {
					show: true,
					fontSize: 10,
					position: 'insideBottom',
					// position: ['50%', '50%']
					// distance:30
				}
			},
			{
				type: 'bar',
				label: {
					show: true,
					fontSize: 10,
					position: 'insideBottom'
				}
			},
			{
				type: 'line',
				yAxisIndex: 1,
				smooth: false,
				symbol: 'circle',
				symbolSize: 8,
				label: {
					show: true,
					color:'#000',
					formatter: '{@同比}%'
				}
			}
		]
	
	};

	let perc_option = {
		color: ['#264D73', '#84B5D5', '#19B3E8'],
		legend: {
			
		},
		title: {
			text: 'Awesome Chart'
		},
		xAxis: {
			type: 'category',
			axisLabel: {
				interval: 0
			}
		},
		yAxis:{
			show:false
		},
	
		series: [{
			type: 'bar',
			stack:'占比',
			 label: {
					show: true,
					fontSize: 10,
					formatter: '{@[1]}%'
				}
		},
		{
			type: 'bar',
			stack:'占比',
			 label: {
					show: true,
					fontSize: 10,
					formatter: '{@[2]}%'
				}
		},
		{
			type: 'bar',
			stack:'占比',
			 label: {
					show: true,
					fontSize: 10,
					formatter: '{@[3]}%'
				}
		}
		]
	};

	function renderMyChart(numType){
		numType=numType||1;
		getCategoryMarketData().then((dt)=>{			
			let region=1;
			jsonData=dt;
			categories.forEach((str,index)=>{
				let datalist=dt[index].dataList;
				datalist=dt.filter((o)=>{
					return o['category']==str;
				});
				// console.log('datalist',datalist)
				datalist=datalist[0].dataList;

				const chart=echarts.getInstanceByDom(refObj[str].current)
				let myChart=null;
				if(chart){
					myChart=chart;
				}else{
					myChart=echarts.init(refObj[str].current);
				}
				if(str==='占比'){
					// console.log('percentOption',percentOption)
					myChart.setOption(percentOption);
					let series=fillSeries(3);
					myChart.setOption({
						series:series
					});
					numType=numType+1;
				}else{
					myChart.setOption(option);
				}
				let res=datalist.map(obj=>{
					let new_obj={};				
					for(let [k,v] of Object.entries(obj)){
						if(Array.isArray(v)){
							// new_obj[k]=v[numType];
							new_obj[k]=v[numType].toFixed(1);
						}else{
							new_obj[k]=v;
						}
					}
					return new_obj;
				})
				// console.log('res',res)	
				
				myChart.setOption({
					title:{'text':str},
					dataset:{
						source:res
					}
				});

			})          
		});
	}
	// 

	useEffect(()=>{
		// console.log("did.....")
		renderMyChart();
		return ()=>{
			// console.log("unmount...");
			myChart && myChart.dispose();
		}
	})
	return (
		<>
		<div>
            <div className="select">
			<Select defaultValue="2" style={{ width: 100 }} onChange={handleChange}>				
				<Option value="2">批发</Option>				
				<Option value="3">零售</Option>				
			</Select>
			</div>
			<div style={{width: "1100px", height: "400px"}} ref={refObj['轿车']} />						
			<div style={{width: "1100px", height: "400px"}} ref={refObj['MPV']} />			
			<div style={{width: "1100px", height: "400px"}} ref={refObj['SUV']} />			
			<div style={{width: "1100px", height: "400px"}} ref={refObj['占比']} />			
			{/* <div style={{width: "1100px", height: "400px"}} ref={chartRef} /> */}
		</div>

		</>
	);
}
